import {
	Dispatch,
	SetStateAction,
} from 'react';
import { Property } from '../../../../models/Property';
import { 
	propertyDocumentCount,
	propertyNameFormatter, 
	propertySaleStatus 
} from '../../../../utilities/propertyUtilities';

interface HeaderProps {
	property: Property;
	setProperty: (val: Property | undefined) => void;
	showDocumentModal: boolean;
	setShowDocumentModal: Dispatch<SetStateAction<boolean>>;
	showBrochure: boolean;
	setShowBrochure: Dispatch<SetStateAction<boolean>>;
	setShowImageModal?: Dispatch<SetStateAction<boolean>>;
};

export default function Header({ property, setProperty, setShowDocumentModal, showDocumentModal, setShowBrochure }: HeaderProps) {
	const { siteBuildingAddress, siteBuildingCity, siteBuildingState, siteBuildingZipCode } = property;
	const addressString = `
    ${siteBuildingAddress ? siteBuildingAddress + ' |' : ''} 
    ${siteBuildingCity + ', ' + siteBuildingState + ' ' + siteBuildingZipCode}`;

	const propertyName = propertyNameFormatter(property);
	const propertyStatus = propertySaleStatus(property);
	const documentCount = propertyDocumentCount(property);

	return (
		<>
			<header>
				<div className="flex-col">
					<div className='summary-page--building-title'>
						{`${propertyName}${propertyStatus}`}
					</div>
					<div className="summary-page--address">
						<div>{addressString}</div>
						{/* <div>{propertySize}</div> */}
					</div>
				</div>
				<div className="summary-page--document-btn__container">
					<button
						className="document-button"
						disabled={property.brochureUrl ? false : true}
						style={{ opacity: property.brochureUrl ? '1' : '0.5' }}
						onClick={() => setShowBrochure(!showDocumentModal)}>
						<span className='esri-icon-duplicate'></span>
						<span>Property Documents</span>
						<div className="tooltip">
							{documentCount > 0 ? `${documentCount} Documents` : 'No Documents'}
						</div>
					</button>
					<button onClick={() => setShowDocumentModal(!showDocumentModal)}>
						<span className='esri-icon-printer'></span>
						<span>Summary PDF</span>
					</button>
					<button className="bg-orange no-border" onClick={() => setProperty(undefined)}>CLOSE</button>
				</div>
			</header>
		</>
	);
}